'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));
var functions = require('@keytrade/functions');
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
var RenderInBody = /*#__PURE__*/function (_Component) {
  function RenderInBody() {
    var _this;
    _classCallCheck(this, RenderInBody);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, RenderInBody, [].concat(args));
    _defineProperty(_this, "update", function () {
      _this.forceUpdate();
    });
    _defineProperty(_this, "renderElement", function () {
      var element = document.getElementById(_this.props.id);
      _this.clonedElement = element.cloneNode(true);
      _this.clonedElement.setAttribute('style', 'visibility:visible;');
      document.body.appendChild(_this.clonedElement);
    });
    return _this;
  }
  _inherits(RenderInBody, _Component);
  return _createClass(RenderInBody, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.renderElement();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      document.body.removeChild(this.clonedElement);
      this.renderElement();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeChild(this.clonedElement);
    }
  }, {
    key: "render",
    value: function render() {
      return React__default.cloneElement(this.props.children, {
        update: this.update
      });
    }
  }]);
}(React.Component);
RenderInBody.propTypes = {
  /** id of the child */
  id: PropTypes.string.isRequired,
  /** The component, text, any that you want to have attached on the body */
  children: PropTypes.any.isRequired
};
var colors = functions.config.colors.list;
var MAX_WIDTH = 20; // rem
var PADDING = 0.7; // rem
var PX_TO_REM = 10;
var SHOW_AFTER_MILLIS = 250;
var StyledTipContent = styled.span.withConfig({
  displayName: "TitleTooltipContent__StyledTipContent",
  componentId: "sc-1icdury-0"
})(["z-index:2500;display:block;position:fixed;max-width:", "rem;top:", "rem;font-size:1.2rem;line-height:1.33;text-align:center;word-break:break-all;word-break:break-word;padding:0.3rem ", "rem;color:", ";background-color:", ";border-radius:0.3rem;pointer-events:none;visibility:hidden;opacity:", ";transition:opacity 0.25s ease-out 0.25s;box-shadow:0 0.1rem 0.3rem 0 ", ",0 0.2rem 0.2rem 0 ", ",0 0 0.2rem 0 ", ";left:", ";right:", ";", ";", ";", " &::before{content:'';z-index:2501;display:block;position:absolute;width:0.6rem;height:0.6rem;top:-0.3rem;left:50%;margin:auto;background:", ";transform:", " ", " rotate(-45deg);transition:opacity 0.25s ease-out 0.25s;box-shadow:0.01rem -0.01rem 0.1rem 0 ", ";clip-path:polygon(calc(100% + 0.1rem) -0.1rem,-0.1rem -0.1rem,calc(100% + 1rem) calc(100% + 1rem));}"], MAX_WIDTH, function (_ref) {
  var positionTop = _ref.positionTop;
  return positionTop;
}, PADDING, colors.BlueDark, colors.White, function (_ref2) {
  var visible = _ref2.visible;
  return visible ? 1 : 0;
}, colors.BlackTransparentLight, colors.BlackTransparentLight, colors.BlackTransparentLight, function (_ref3) {
  var positionLeft = _ref3.positionLeft,
    left = _ref3.left,
    right = _ref3.right;
  if (left < 0) {
    return '0rem';
  }
  if (right < 0) {
    return 'auto';
  }
  return "".concat(positionLeft, "rem");
}, function (_ref4) {
  var right = _ref4.right;
  if (right < 0) {
    return '0rem';
  }
  return 'auto';
}, function (_ref5) {
  var left = _ref5.left,
    right = _ref5.right;
  if (left < 0 || right < 0) {
    return '';
  }
  return 'transform: translateX(-50%);';
}, function (_ref6) {
  var tipWidth = _ref6.tipWidth;
  return !tipWidth && 'white-space: nowrap;';
}, function (_ref7) {
  var tipWidth = _ref7.tipWidth;
  return tipWidth && "width: ".concat(tipWidth + PADDING, "rem;");
}, colors.White, function (_ref8) {
  var left = _ref8.left;
  return left < 0 && "translateX(".concat(left - 0.3, "rem)");
}, function (_ref9) {
  var right = _ref9.right;
  return right < 0 && "translateX(".concat(right * -1, "rem)");
}, colors.BlackTransparentLight);
var TitleTooltipContent = /*#__PURE__*/function (_PureComponent) {
  function TitleTooltipContent(props) {
    var _this;
    _classCallCheck(this, TitleTooltipContent);
    _this = _callSuper(this, TitleTooltipContent, [props]);
    _this.state = {
      tipWidth: null,
      left: null,
      right: null,
      isVisible: false
    };
    return _this;
  }
  _inherits(TitleTooltipContent, _PureComponent);
  return _createClass(TitleTooltipContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.tip) {
        var _this$tip$getBounding = this.tip.getBoundingClientRect(),
          width = _this$tip$getBounding.width,
          left = _this$tip$getBounding.left,
          right = _this$tip$getBounding.right;
        this.setState({
          tipWidth: width / PX_TO_REM,
          left: left / PX_TO_REM,
          right: (/* istanbul ignore next */
          typeof window !== 'undefined' ? window.innerWidth - right : 0) / PX_TO_REM
        });
      }
      this.showTimer = setTimeout(function () {
        _this2.setState({
          isVisible: true
        });
      }, SHOW_AFTER_MILLIS);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.update();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.showTimer) {
        clearTimeout(this.showTimer);
        this.showTimer = 0;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        id = _this$props.id,
        tip = _this$props.tip,
        positionLeft = _this$props.positionLeft,
        positionTop = _this$props.positionTop;
      var _this$state = this.state,
        tipWidth = _this$state.tipWidth,
        left = _this$state.left,
        right = _this$state.right,
        isVisible = _this$state.isVisible;
      return /*#__PURE__*/React__default.createElement(StyledTipContent, {
        id: id,
        innerRef: function innerRef(ref) {
          return _this3.tip = ref;
        },
        positionLeft: positionLeft,
        positionTop: positionTop,
        tipWidth: tipWidth,
        left: left,
        right: right,
        visible: isVisible
      }, tip);
    }
  }]);
}(React.PureComponent);
TitleTooltipContent.propTypes = {
  /** Tooltip id */
  id: PropTypes.string.isRequired,
  /** Tip is text / component that will fill the tooltip */
  tip: PropTypes.any.isRequired,
  /** Left position where the tooltip should start */
  positionLeft: PropTypes.number.isRequired,
  /** Top position where the tooltip should start */
  positionTop: PropTypes.number.isRequired,
  /** A prop that is passed by RenderInBody to update the component out of react */
  update: PropTypes.func
};
TitleTooltipContent.defaultProps = {
  update: function update() {}
};
var TIPCONTENT_MARGIN = 0.5; // rem
var PX_TO_REM$1 = 10;
function flexDirection(directionProp) {
  switch (directionProp) {
    case 'column':
      return 'column';
    case 'row':
    default:
      return 'row';
  }
}
var StyledTip = styled.span.withConfig({
  displayName: "TitleTooltip__StyledTip",
  componentId: "sc-uh0485-0"
})(["margin:", ";position:relative;display:flex;flex-direction:", ";vertical-align:top;max-width:100%;> *:not(:last-child){display:block;overflow:hidden;text-overflow:ellipsis;max-width:100%;}"], function (props) {
  return props.margin;
}, function (_ref) {
  var direction = _ref.direction;
  return flexDirection(direction);
});
var TitleTooltip = /*#__PURE__*/function (_PureComponent) {
  function TitleTooltip(props) {
    var _this;
    _classCallCheck(this, TitleTooltip);
    _this = _callSuper(this, TitleTooltip, [props]);
    _defineProperty(_this, "handleMouseEnter", function () {
      var _this$baseItem$getBou = _this.baseItem.getBoundingClientRect(),
        left = _this$baseItem$getBou.left,
        width = _this$baseItem$getBou.width,
        bottom = _this$baseItem$getBou.bottom;
      _this.setState({
        hover: true,
        left: (left + width / 2) / PX_TO_REM$1,
        top: bottom / PX_TO_REM$1 + TIPCONTENT_MARGIN
      });
    });
    _defineProperty(_this, "hideTooltip", function () {
      return _this.setState({
        hover: false
      });
    });
    _this.state = {
      hover: false,
      left: 0,
      top: 0
    };
    return _this;
  }
  _inherits(TitleTooltip, _PureComponent);
  return _createClass(TitleTooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('scroll', this.hideTooltip);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('scroll', this.hideTooltip);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        id = _this$props.id,
        children = _this$props.children,
        tip = _this$props.tip,
        margin = _this$props.margin,
        className = _this$props.className,
        direction = _this$props.direction,
        tabIndex = _this$props.tabIndex,
        noTabIndex = _this$props.noTabIndex;
      var _this$state = this.state,
        hover = _this$state.hover,
        left = _this$state.left,
        top = _this$state.top;
      return /*#__PURE__*/React__default.createElement(StyledTip, {
        innerRef: function innerRef(ref) {
          return _this2.baseItem = ref;
        },
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.hideTooltip,
        onFocus: this.handleMouseEnter,
        onBlur: this.hideTooltip,
        margin: margin,
        className: className,
        direction: direction,
        tabIndex: !noTabIndex && (tabIndex ? tabIndex : '0')
      }, children, hover && /*#__PURE__*/React__default.createElement(RenderInBody, {
        id: id
      }, /*#__PURE__*/React__default.createElement(TitleTooltipContent, {
        id: id,
        tip: tip,
        positionLeft: left,
        positionTop: top
      })));
    }
  }]);
}(React.PureComponent);
TitleTooltip.propTypes = {
  /** Tooltip id, must be unique */
  id: PropTypes.string.isRequired,
  /** Tip is text / component that will fill the tooltip */
  tip: PropTypes.any.isRequired,
  /** This will be the component that you hover over that shows the TitleTooltip */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  /** this will add a margin shortcut css rule */
  margin: PropTypes.string,
  /** Alignment of the children. Allowed values: row, column. */
  direction: PropTypes.oneOf(['row', 'column']),
  /** set TabIndex */
  tabIndex: PropTypes.int
};
TitleTooltip.defaultProps = {
  direction: 'row'
};
exports.TitleTooltip = TitleTooltip;